module.exports = __webpack_public_path__ + "img/142.17fa6592.jpg";